import { useUpdateEmailSubscription } from "@/app/api"
import { RootState } from "@/app/store"
import { renderDLAPP } from "@/assets/dlapp"
import present from "/src/assets/present.png"
import { changeSubscribed } from "@/app/appSlice"

export default function Success() {
  const t = useTranslate()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const updateEmailSubscription = useUpdateEmailSubscription()

  const [email, setEmail] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [buttonEnabled, setButtonEnabled] = useState(false)
  const [countdown, setCountdown] = useState(5) // Add countdown state

  const earnPointsResponse = useAppSelector(
    (state: RootState) => state.app.earnPointResponse,
  )
  const subscribed = useAppSelector((state: RootState) => state.app.subscribed)
  const phone = useAppSelector((state: RootState) => state.app.phone)
  const txnGA = useAppSelector((state: RootState) => {
    return { ...state.app.txnGA, invoiceQRCode: state.app.invoiceQRCode }
  })

  useEffect(() => {
    window.gtag("event", "result_page", { ...txnGA })
  })

  const ga = (platform: string) => {
    window.gtag("event", "download_app", { platform, ...txnGA })
  }

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setEmail(value)

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(value)) {
      setErrorMessage(t("success.message.enterValidEmail"))
      setButtonEnabled(false)
    } else {
      setErrorMessage("")
      setButtonEnabled(true)
    }
  }

  const onEmailSubscribe = async () => {
    try {
      await updateEmailSubscription(phone, email)
      setErrorMessage("")
      dispatch(changeSubscribed(true))
    } catch (e: any) {
      setErrorMessage(e)
    }
  }

  // Add redirect effect
  useEffect(() => {
    if (earnPointsResponse && earnPointsResponse.merchantWebsiteUrl) {
      const timer = setInterval(() => {
        setCountdown((prevCount) => {
          if (prevCount <= 1) {
            clearInterval(timer)
            window.location.href = earnPointsResponse.merchantWebsiteUrl!!
            return 0
          }
          return prevCount - 1
        })
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [earnPointsResponse])

  return (
    earnPointsResponse && (
      <div className="body">
        <div className="receipt">
          <img className="centered-image" src={present}></img>

          <p className="text1 mt-2">{t("success.title.earnPoints")}</p>
          <p className="text2 mt-4">{t("success.title.currentPoints")}</p>
          <p className="point-lg">{earnPointsResponse!!.points}</p>
          <p className="text2">{t("success.title.downloadApp")}</p>
          {earnPointsResponse!!.customImageUrl &&
            earnPointsResponse!!.customImageRedirectUrl && (
              <a
                href={earnPointsResponse!!.customImageRedirectUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={earnPointsResponse!!.customImageUrl}
                  className="centered-image mt-2"
                  alt="Custom"
                />
              </a>
            )}

          {earnPointsResponse!!.customImageUrl &&
            !earnPointsResponse!!.customImageRedirectUrl && (
              <img
                src={earnPointsResponse!!.customImageUrl}
                className="centered-image mt-2"
                alt="Custom"
              />
            )}

          {earnPointsResponse!!.customMessage && (
            <p className="text2 mt-4">{earnPointsResponse!!.customMessage}</p>
          )}

          {earnPointsResponse &&
            earnPointsResponse.hasEmail &&
            earnPointsResponse.merchantWebsiteUrl && (
              <div className="mt-4">
                <p className="text2 mt-2">
                  {t("success.redirect.instruction", {
                    seconds: countdown.toString(),
                  })}
                </p>
                <a href={earnPointsResponse.merchantWebsiteUrl}>
                  <button className="confirm-button">
                    {t("success.button.returnToWebsite")}
                  </button>
                </a>
              </div>
            )}

          {!earnPointsResponse!!.hasEmail && (
            <>
              <p className="text1 mt-4">
                {t("success.title.subscribeStorellet")}
              </p>
              <div className="flex flex-col mt-4">
                <p className="text2 text-left">
                  {t("success.title.emailAddress")}
                </p>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  placeholder={t("success.placeholder.emailAddress")}
                  onChange={onEmailChange}
                  disabled={subscribed}
                  className={errorMessage ? "input-error" : ""}
                />
                {errorMessage && (
                  <p className="text-error text-left">{errorMessage}</p>
                )}
                <p className="text2">
                  {t("success.title.subscribeAgreementPart1")}
                  <a
                    onClick={() => {
                      navigate("/tnc")
                    }}
                    className="link"
                  >
                    {t("success.title.subscribeAgreementPart2")}
                  </a>
                  {t("success.title.subscribeAgreementPart3")}
                  <a
                    onClick={() => {
                      navigate("/privatePolicy")
                    }}
                    className="link"
                  >
                    {t("success.title.subscribeAgreementPart4")}
                  </a>
                  {t("success.title.subscribeAgreementPart5")}
                </p>
              </div>
              <div>
                {!subscribed && (
                  <button
                    className="confirm-button"
                    onClick={onEmailSubscribe}
                    disabled={!buttonEnabled}
                  >
                    {t("success.button.subscribe")}
                  </button>
                )}

                {subscribed && (
                  <button className="confirm-button" disabled={true}>
                    {t("success.title.subscribeSuccessfully")}
                  </button>
                )}
              </div>
              {earnPointsResponse && earnPointsResponse.merchantWebsiteUrl && (
                <div>
                  <p className="text2 mt-2">
                    {t("success.redirect.instruction", {
                      seconds: countdown.toString(),
                    })}
                  </p>
                  <a href={earnPointsResponse.merchantWebsiteUrl}>
                    <button className="simple-button">
                      {t("success.button.returnToWebsite")}
                    </button>
                  </a>
                </div>
              )}
            </>
          )}
        </div>

        <p className="text1">{t("downloadApp")}</p>
        <div className="my-2">
          {renderDLAPP({ onClick: ga, centered: true })}
        </div>
      </div>
    )
  )
}
